// Shared between DriverFormModal.jsx (Owner Operators type in their own
// equipment) and AssetsTab.jsx (Company Driver equipment is fleet-owned,
// tracked as Assets, and its type belongs on the Asset itself -- see
// AssetsTab.jsx's handleSave, which syncs it onto the assigned driver's
// profile). One list so the two can't drift apart.

// Truck (tractor / power unit) options. This is the VEHICLE the driver
// operates, NOT the freight equipment behind it. Day Cab / Sleeper are
// the OTR mainstays; Box Truck / Hot Shot / Cargo Van / Pickup cover
// expediting + LTL + last-mile use cases.
export const TRUCK_TYPES = [
  'Day Cab',
  'Sleeper',
  'Box Truck',
  'Hot Shot',
  'Cargo Van',
  'Pickup',
  'Other',
];

// Trailer (freight equipment) options. This is what determines what
// kinds of market loads the driver can match. Power Only covers
// drivers who run bare tractor and hook to broker-supplied trailers.
export const TRAILER_TYPES = [
  'Dry Van',
  'Reefer',
  'Flatbed',
  'Step Deck',
  'RGN',
  'Tanker',
  'Lowboy',
  'Power Only',
  'Other',
];
